import { useNavigate } from "react-router-dom";
import { BiChevronLeft } from "react-icons/bi";
import {
  MdOutlineAccountBalanceWallet,
  MdOutlineTouchApp,
  MdOutlineLink,
  MdOutlineChecklist,
  MdOutlineAddLink,
} from "react-icons/md";
import ex2 from "../../asset/Images/faq/integration/connection/2.png";
import ex3 from "../../asset/Images/faq/integration/connection/3.png";
import ex1 from "../../asset/Images/faq/integration/connection/1.png";
import ex4 from "../../asset/Images/faq/integration/connection/4.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import styles from "../../styles/Components/faq/ExchangesConnectionHelp.module.css";

function ExchangesConnectionHelp() {
  const navigate = useNavigate();

  return (
    <div className={styles.helpWrapper}>
      <div className={styles.backBtn} onClick={() => navigate("/faq/all")}>
        <BiChevronLeft />
        <span>Back to Help Center</span>
      </div>

      <div className={`${styles.heroCard} ${styles.heroExchange}`}>
        <div className={`${styles.heroIcon} ${styles.heroIconExchange}`}>
          <MdOutlineAccountBalanceWallet />
        </div>
        <div className={styles.heroContent}>
          {/* <div className={styles.heroEyebrow}>
            <MdOutlineLink />
            Exchange Integrations
          </div> */}
          <h3 className={styles.heroTitle}>Connect to Exchange</h3>
          <p className={styles.heroDesc}>
            Link your favorite exchange accounts to start trading, deploying
            bots, and managing your portfolio from one unified dashboard.
          </p>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={`${styles.stepNumWrap} ${styles.stepNumExchange}`}>
            <span className={styles.stepNum}>1</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Initiate Connection</h4>
            <div className={styles.stepTag}>
              <MdOutlineAddLink />
              First Step
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <ul className={styles.helpList}>
              <li>Click on the "Connect To Exchange".</li>
            </ul>
            <div className={styles.imageWrap}>
              <LazyLoadImage
                src={ex1}
                alt="create bot"
                effect="blur"
                wrapperClassName="imageContainer"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={`${styles.stepNumWrap} ${styles.stepNumExchange}`}>
            <span className={styles.stepNum}>2</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Select Your Exchange</h4>
            <div className={`${styles.stepTag} ${styles.tagPick}`}>
              <MdOutlineTouchApp />
              Pick an Exchange
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <ul className={styles.helpList}>
              <li>
                Click on your preferred exchange to access and complete the
                necessary settings to connect it easily.
              </li>
            </ul>
            <div className={styles.imageWrap}>
              <LazyLoadImage
                src={ex2}
                alt="create bot"
                effect="blur"
                wrapperClassName="imageContainer"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={`${styles.stepNumWrap} ${styles.stepNumExchange}`}>
            <span className={styles.stepNum}>3</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Enter Credentials & Connect</h4>
            <div className={`${styles.stepTag} ${styles.tagConnect}`}>
              <MdOutlineLink />
              Authenticate
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <ul className={styles.helpList}>
              <li>
                Enter the connection info and then click on the "Connect"
                button.
              </li>
            </ul>
            <div className={styles.imageWrap}>
              <LazyLoadImage
                src={ex4}
                alt="create bot"
                effect="blur"
                wrapperClassName="imageContainer"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={`${styles.stepNumWrap} ${styles.stepNumExchange}`}>
            <span className={styles.stepNum}>4</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Manage Connected Exchanges</h4>
            <div className={`${styles.stepTag} ${styles.tagManage}`}>
              <MdOutlineChecklist />
              Connected Exchanges
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <ul className={styles.helpList}>
              <li>
                In the "Connected Exchanges" card, quickly access and manage all
                exchanges you've already connected to.
              </li>
            </ul>
            <div className={styles.imageWrap}>
              <LazyLoadImage
                src={ex3}
                alt="ai assistant"
                effect="blur"
                wrapperClassName="imageContainer"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExchangesConnectionHelp;
